
$(document).ready(function () {


	$('select').selectize();
	//styling number input
   $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.filters__numberWrapper input');

	$(".main_input_file").change(function() {

			var f_name = [];

			for (var i = 0; i < $(this).get(0).files.length; ++i) {

				f_name.push($(this).get(0).files[i].name + "<br>");

			}

			$("#f_name").html(f_name);
		});


		if ($(window).width() > 1020) {
			$('.sidebarMenu').stick_in_parent({
				offset_top: 120
			});
		}

	$(".hover").mouseleave(
	  function () {
	    $(this).removeClass("hover");
	  }
	);


	AOS.init({
		   disable: 'mobile',
       offset: 200,
       duration: 600,
       delay: 100,});

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 145) {
			AOS.refresh();

      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });


	//language switcher
	$('.js-top__language').on('click',function(){
			$(this).toggleClass('top__language--open');
			return false;
	});

		//language switcher
	$('.js-top__language a:not(.active)').on('click',function(){
				$(this).addClass('active').siblings().removeClass('active');
				window.location.href = $(this).attr('href');
		});

$(".sliderHome .owl-carousel").owlCarousel({
	 items:1,
	 margin:0,
	 stagePadding:0,
	 smartSpeed:450,
	 animateOut: 'animate__animated animate__fadeOut',
	 animateIn: 'animate__animated animate__fadeIn',
	 autoplay:false,
	 nav:true,
	 navText : ["",""],
	 loop:true,
	 lazyLoad: true,
	 dots:false,
	 autoplayTimeout:7000,
	 autoplayHoverPause:true
});

$(".slider--sub .owl-carousel").owlCarousel({
	items:1,
	margin:0,
	stagePadding:0,
	smartSpeed:450,
	animateOut: 'fadeOut',
	animateIn: 'fadeIn',
	autoplay:true,
	nav:true,
	navText : ["",""],
	loop:true,
	dots:true,
	autoplayTimeout:7000,
	autoplayHoverPause:true
});
	var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    ms = document.querySelector('body');

  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if ((body.scrollTop || ms.scrollTop) >= 100) {
      header.classList.add('short');
    } else {
      header.classList.remove('short');
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });


	$(function(){
	  $('a[href^="#"]').on('click', function(event) {

	    event.preventDefault();

	    var sc = $(this).attr("href"),
	        dn = $(sc).offset().top - 200;


	    $('html, body').animate({scrollTop: dn}, 1000);

	  });
	});

});
